module.exports = __webpack_public_path__ + "img/facturasRutas64.6f36f69b.png";